<template>
  <span v-if="diff" class="fw-bold text-danger">! ({{ diff }}) </span>
</template>
<script setup>
import { defineProps, ref, onMounted, computed } from "vue";
import supabase from "@/supabase/config";
const props = defineProps(["pool_id"]);
const pool_list_count = ref(0);
const players_count = ref(0);
onMounted(() => {
  fetchPoolListCount();
  fetchPlayerCount();
});
const fetchPoolListCount = async () => {
  let { data: pool_list, error } = await supabase
    .from("pool_list")
    .select("*")
    .eq("pool_id", props.pool_id);
  pool_list_count.value = pool_list.length;
};
const fetchPlayerCount = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("pool_id", props.pool_id);
  players_count.value = players.length;
};
const diff = computed(() => {
  var difference = 0;
  difference = players_count.value - pool_list_count.value;
  return difference;
});
</script>
